import { StringFormatter } from '@repo/toolkit/string'
import { toFullName } from '@repo/toolkit/to-full-name'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import Button from '@repo/ui/button'
import { ChevronLeftIcon, TeachingIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { getTefl } from '../../api/tefl/get-tefl'
import LoadingScreen from '../../components/elements/loading/loading-screen'
import UserNavBar from '../../components/elements/nav-bar'
import OlTeflDetails from '../../components/pages/ols/ol-tefl/ol-tefl-details'
import TeflLecCommentTable from '../../components/pages/ols/ol-tefl/tefl-lec-comment-table'
import TeflOlComments from '../../components/pages/ols/ol-tefl/tefl-ol-comments'
import NotFoundPage from '../common/not-found'

const OlTeflViewPage = () => {
  const { teflId, olId } = useParams<{ teflId: string; olId: string }>()
  const { back } = useNavigator()

  if (!teflId || isNaN(+teflId)) return

  const { data: tefl, isPending } = useQuery({
    queryKey: ['tefl', teflId],
    queryFn: () => {
      if (!olId || isNaN(+olId)) return

      return getTefl(+teflId, +olId)
    }
  })

  if (isPending) return <LoadingScreen />
  if (!tefl) return <NotFoundPage />

  return (
    <div>
      <UserNavBar title={toFullName(tefl.firstName, tefl.lastName)} icon={TeachingIcon} />
      <div className="h-4" />
      <Box className="flex flex-col gap-4 ">
        <Button
          icon={ChevronLeftIcon}
          label="Retour"
          variant="ghost"
          className="border-grey-light w-fit"
          onClick={() => back()}
        />
        <div className="flex justify-between items-center w-full">
          <div className="flex gap-2 items-center">
            <Typography variant="h6" className="mr-2">
              TEFL {tefl?.firstName ? StringFormatter.capitalize(tefl.firstName) : ''}
            </Typography>
          </div>
        </div>
        <OlTeflDetails tefl={tefl} olId={Number(olId)} />
      </Box>
      <div className={'h-4'} />
      <Box>
        <TeflLecCommentTable id={Number(teflId)} />
        <div className={'h-4'} />
        <TeflOlComments id={Number(teflId)} />
      </Box>
    </div>
  )
}

export default OlTeflViewPage
